'use client';
import Link from 'next/link';
import { useAppSelector } from '@/lib/redux/hooks';

import CartTableRow from './CartTableRow';
import { pushToDataLayer, toGa4CartItem } from '@/features/gtm/gtmUtils';

const Cart = () => {
  const { items } = useAppSelector((state) => state.cart);
  const total = items.reduce(
    (acc, curr) => acc + curr.price * curr.quantity,
    0
  );
  const handleBeginCheckout = () => {
    pushToDataLayer('begin_checkout', {
      ecommerce: {
        value: total,
        currency: 'BDT',
        items: items.map((item) =>
          toGa4CartItem(item),
        ),
      },
    });
  };

  return (
    <>
      <div className="cart__product">
        {items.length > 0 ? (
          items.map((item, i) => (
            <CartTableRow key={i} product={item} total={total} />
          ))
        ) : (
          <div className="text-center text-muted py-5 border rounded">
            Your cart is empty.
          </div>
        )}

        {/* Cart Footer */}
        {items.length > 0 && (
          <div className="row g-4">
            <div className=" col-12">
              <div className="cart__footer">
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div>
                    <label
                      htmlFor="cart-total"
                      className="form-label fw-medium mb-1"
                    >
                      Cart Total
                    </label>
                    <h5 className="mb-0">৳{total.toFixed(2)}</h5>
                  </div>
                  <Link
                    href="/checkout"
                    className="trk-btn trk-btn--primary trk-btn--lg"
                    onClick={handleBeginCheckout}
                  >
                    Proceed to checkout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Cart;
